import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { asyncMessagesLoader } from './asyncMessagesLoader';
export class TranslationsState {
  constructor(_params) {
    _defineProperty(this, "i18n", void 0);
    _defineProperty(this, "_initPromise", void 0);
    _defineProperty(this, "_ready", void 0);
    _defineProperty(this, "translate", (key, params) => this.i18n.t(key, params));
    _defineProperty(this, "getTranslateFn", async () => {
      await this.getInitPromise();
      return this.translate;
    });
    this.i18n = _params.createI18n({
      asyncMessagesLoader,
      disableAutoInit: true
    });
    this._initPromise = new Promise(async resolve => {
      var _this$i18n$on, _this$i18n2;
      let failedLoading = false;
      const onFailedLoading = (lng, _ns, err) => {
        var _this$i18n$off, _this$i18n;
        // reject only when fallback lang (en) fails to load
        if (lng !== 'en') {
          return;
        }
        (_this$i18n$off = (_this$i18n = this.i18n).off) == null || _this$i18n$off.call(_this$i18n, 'failedLoading', onFailedLoading);
        failedLoading = true;
        resolve(err);
      };
      (_this$i18n$on = (_this$i18n2 = this.i18n).on) == null || _this$i18n$on.call(_this$i18n2, 'failedLoading', onFailedLoading);
      try {
        await this.i18n.init();
        if (failedLoading) {
          return;
        }
        resolve(null);
        this._ready = true;
      } catch (e) {
        resolve(e);
      }
    });
  }
  async getInitPromise() {
    const error = await this._initPromise;
    if (error) {
      throw error;
    }
  }
}
//# sourceMappingURL=TranslationsState.js.map